import { type GetFeatureRouteArgs } from '../types';
import { type NavBarItem } from '../Navbar/NavbarContent';

export const getFeatureRoute = ({ isFeatureEnabled, route, unavailableRoute }: GetFeatureRouteArgs) => {
  if (isFeatureEnabled) return route;

  const routeId = route.replace(/\//g, '-').replace(/^-/, '');
  return unavailableRoute ?? `/feature-disabled/${routeId}`;
};

// Hero-only nav entries are marked with `heroOnly` in navConfig. Parents left without children are
// dropped too: NavItems renders an empty `items` array as a dead, unclickable row.
export const filterHeroOnly = (items: NavBarItem[], isHeroAdmin: boolean): NavBarItem[] =>
  isHeroAdmin
    ? items
    : items
        .filter(item => !item.heroOnly)
        .map(item => (item.items ? { ...item, items: filterHeroOnly(item.items, isHeroAdmin) } : item))
        .filter(item => !item.items || item.items.length > 0);
